import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import TicketSiteCreateForm from './TicketSiteCreateForm'
import TicketSiteItem from './TicketSiteItem'
export default function TicketSitesDisplay ({
  ticketSites,
  ticketSiteCosts,
  ticketSiteCostNotes,
  sites,
  onSubmit,
  onDestroy,
  onSubmitCostToTicketSite,
  disabled = false,
  saveDisabled = false,
  expandedSiteCost,
  setExpandedSiteCost
}) {
  const nonMatchedSites = useMemo(
    () => sites.filter(site => !ticketSites.some(ticketSite => site.id === ticketSite.id)),
    [sites, ticketSites]
  )

  return (
    <div className='dis-panel'>
      <div className='dis-panel-header'>
        <h5>Associated Sites</h5>
      </div>
      <div className='dis-panel-body'>
        <TicketSiteCreateForm onSubmit={onSubmit} sites={nonMatchedSites} disabled={disabled} />
        {ticketSites.map((ticketSite, index) => {
          const savedSiteCost = ticketSiteCosts.find(ticketSiteCost => ticketSiteCost.siteId === ticketSite.id)
          const hasSiteCost = Boolean(ticketSite.cost)
          const siteCostNote = ticketSiteCostNotes?.find((ticketSiteCostNote) => ticketSiteCostNote.site.id === ticketSite.id)
          const siteInfo = {
            disposalCost: savedSiteCost?.cost || ticketSite.cost,
            totalCost: siteCostNote?.cost,
            note: siteCostNote?.notes
          }
          return (
            <TicketSiteItem
              key={ticketSite.id}
              ticketSite={ticketSite}
              index={index}
              totalSites={ticketSites.length}
              siteInfo={siteInfo}
              hasSiteCost={hasSiteCost || savedSiteCost}
              siteCostNote={siteCostNote}
              expandedSiteCost={expandedSiteCost}
              setExpandedSiteCost={setExpandedSiteCost}
              onSubmitCost={onSubmitCostToTicketSite}
              saveDisabled={saveDisabled}
              onRemove={(siteId) => onDestroy({ siteId })}
            />
          )
        })}
      </div>
    </div>
  )
}

TicketSitesDisplay.propTypes = {
  ticketSites: PropTypes.array.isRequired,
  ticketSiteCosts: PropTypes.array.isRequired,
  ticketSiteCostNotes: PropTypes.array.isRequired,
  sites: PropTypes.array.isRequired,
  onDestroy: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onSubmitCostToTicketSite: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  expandedSiteCost: PropTypes.array.isRequired,
  setExpandedSiteCost: PropTypes.func.isRequired
}
